import { inject, Injectable } from '@angular/core';
import { _AuthBaseStore, AuthBaseStoreLoginModel, AuthBaseStoreProps } from '@controladad/ng-base';
import { map, of, tap } from 'rxjs';
import { AuthApiService, UserApiService } from '@admin/core/services';
import { getUserPermissionKeys } from '@admin/shared/helpers';
import { AppStore } from './app.store';

export interface AuthUserProfile {
  id: number;
  firstName: string;
  lastName: string;
  username: string;
  lastSyncedAt: string;
  permissions: string[];
  permissionIds: number[];
}
export interface AuthStoreProp extends AuthBaseStoreProps<AuthUserProfile> { }
export interface AuthStoreLoginModel extends AuthBaseStoreLoginModel { }

@Injectable({
  providedIn: 'root'
})
export class AuthStore extends _AuthBaseStore<AuthStoreProp, AuthStoreLoginModel> {
  private authApi = inject(AuthApiService);
  private userApi = inject(UserApiService);
  private appStore = inject(AppStore);


  constructor() {
    super({
      loginApi: (model) => this.authApi.login({
        username: model.username,
        password: model.password,
      }).pipe(map((res) => ({
        token: res.token,
        user: {
          ...res.user,
          permissions: [],
          permissionIds: res.user.permissions,
        },
      }))),
      meApi: () => of(undefined),
    });
  }

  updateProfile() {
    const state = this.state;
    const user = state.user;
    const userId = user?.id;
    if (!userId) return of(null);
    return this.userApi.getProfile(userId).pipe(tap((profile) => {
      this.patch({
        ...state,
        user: {
          ...profile,
          permissionIds: profile.effectivePermissions,
          permissions: getUserPermissionKeys(this.appStore.state.allAppPermissions, profile.effectivePermissions),
        },
      })
    }))
  }
}
